import { render, staticRenderFns } from "./SchoolCounselingConfigModal.Style#Drawer.vue?vue&type=template&id=856b330c&scoped=true"
import script from "./SchoolCounselingConfigModal.Style#Drawer.vue?vue&type=script&lang=js"
export * from "./SchoolCounselingConfigModal.Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./SchoolCounselingConfigModal.Style#Drawer.vue?vue&type=style&index=0&id=856b330c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856b330c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('856b330c')) {
      api.createRecord('856b330c', component.options)
    } else {
      api.reload('856b330c', component.options)
    }
    module.hot.accept("./SchoolCounselingConfigModal.Style#Drawer.vue?vue&type=template&id=856b330c&scoped=true", function () {
      api.rerender('856b330c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolCounselingConfig/modules/SchoolCounselingConfigModal.Style#Drawer.vue"
export default component.exports